import type { FC } from "react";

import { translate } from "app/filters/i18nFilter";

import { SearchOverviewTexts } from "../../../../texts";
import { changeIndicatorComponent } from "../../../TableCells/tableCells";

import { ChangeValueWrapper, GranularityIndicator, InlineCellWrapper } from "./styledComponents";

interface ChangeIndicatorProps {
    change: number;
}
const ChangeIndicator: FC<ChangeIndicatorProps> = ({ change }) => {
    return (
        <ChangeValueWrapper>
            <InlineCellWrapper>{changeIndicatorComponent(change, "right")}</InlineCellWrapper>
            <GranularityIndicator
                isIncrease={change > 0}
                unsigned={change === 0}
            >
                {translate(SearchOverviewTexts.yoy)}
            </GranularityIndicator>
        </ChangeValueWrapper>
    );
};

export default ChangeIndicator;
